module.exports = __webpack_public_path__ + "static/media/cartIcon.c2af0377.svg";